import { getFont } from '@24i/nxg-sdk-higgs';
import { Theme } from '@24i/nxg-sdk-photon/src';

const getSettingsDropdownPickerStyles = (theme: Theme) => ({
    selectContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottomColor: theme.color.lighter3,
        borderBottomWidth: 0.5,
    },
    description: {
        color: theme.color.textPrimary,
        ...getFont(theme, 'h4'),
    },
    buttonText: {
        color: theme.color.textPrimary,
        ...getFont(theme, 'h5'),
    },
    buttonContainer: {
        backgroundColor: 'transparent',
    },
});

export default getSettingsDropdownPickerStyles;
